import Icon from "@material-ui/icons/Person";
import HolidayCreate from "./CcaHolidayCreate";
import HolidayEdit from "./CcaHolidayEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaHolidays",
  edit: HolidayEdit,
  create: HolidayCreate,
  icon: Icon,
};
